import React from 'react';

import Statusbar from 'sharedreact/components/Statusbar';

type Props = {
  children?: React.ReactNode;
};

class HomeStatusbar extends React.Component<Props> {
  override render (): React.ReactNode {
    const {
      children
    } = this.props;

    const statusbarContents = [
      <div key='0'>{children}</div>,
      <div key='1' className='esko_statusbar-right' />,
      <div key='2'>Home</div>
    ];

    return (
      <Statusbar>{statusbarContents}</Statusbar>
    );
  }
}

export default HomeStatusbar;
